var render = function () {
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.profilePictureImgWrapper] = true, _class[_vm.$style.active] = _vm.active, _class[_vm.$style.profilePictureImgHoverEffect] = _vm.hoverEffect, _class)
  }, [_c('img', {
    class: (_class2 = {}, _class2[_vm.$style.profilePictureImg] = true, _class2),
    attrs: {
      "src": _vm.picturePath
    },
    on: {
      "error": function error($event) {
        _vm.errorLoading = true;
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }